package components.colourToneItem

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 03.11.22
 * Author : marcusspors
 */
enum class EColourToneItemLeftButtonType {
    // ----------------------------------------------------------------------------
    // Enumeration List
    // ----------------------------------------------------------------------------

    WATCH_LIST,
    PRODUCT_LIST

    // ----------------------------------------------------------------------------
    // Public methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private methods
    // ----------------------------------------------------------------------------
}